export default __webpack_public_path__ + "static/media/dangerIcon.1e1d2f81.svg";